import { adminActions } from "./actions";
import { IOrganizationInitialState, IUser } from "./interface";

export const initialState: IOrganizationInitialState = {
  organizationData: {
    orgnizationDetails: {},
    userAttributes: {}
  },
  isAdminLoading: false,
  userList: [],
  userListLoading: false,
  userListError: null,
};

export const adminReducer = (
  state: IOrganizationInitialState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {

    // Organization data actions...
    case adminActions.ADD_ORGANIZATION_DATA: {
      return {
        ...state,
        isAdminLoading: true,
      };
    }
    case adminActions.ADD_ORGANIZATION_DATA_SUCCESS: {
      const updatedOrganizationData = action.payload?.organizationData;
      return {
        ...state,
        organizationData: updatedOrganizationData,
        isAdminLoading: false,
      };
    }
    case adminActions.ADD_ORGANIZATION_DATA_FAILURE: {
      return {
        ...state,
        isAdminLoading: false,
      };
    }

    // Handle user list actions...
    case adminActions.FETCH_USER_LIST_REQUEST: {
      return {
        ...state,
        userListLoading: true,
      };
    }
    case adminActions.FETCH_USER_LIST_SUCCESS: {
      return {
        ...state,
        userList: action.payload,
        userListLoading: false,
      };
    }
    case adminActions.FETCH_USER_LIST_FAILURE: {
      return {
        ...state,
        userListLoading: false,
      };
    }

    default:
      return { ...state };
  }
};
